// Log Event: Time, Name, Order
export class Logger {

}
